import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import DeactivateVirtualCardContent from 'src/app/DeactivateVirtualCardContent/DeactivateVirtualCardContent'
import {
  selectVirtualCardIdFromRoute,
  selectVirtualCardListModel,
} from 'src/app/DeactivateVirtualCardContent/redux/deactivateVirtualCardContent.selectors'
import { useFlyoutDispatch } from 'src/hooks'
import { connectedReplace } from 'src/navigation/Lnk'
import { deactivateVirtualCardUrl } from 'src/navigation/urls'
import {
  getVirtualCard,
  getVirtualCardPermissions,
} from 'src/redux/actions/data/virtualCards.actions'

const DeactivateBillPayCard: React.FC = () => {
  const dispatch = useFlyoutDispatch()
  const virtualCardId = useSelector(selectVirtualCardIdFromRoute)
  const virtualCard = useSelector(selectVirtualCardListModel)

  useEffect((): void => {
    dispatch(getVirtualCard(virtualCardId))
    dispatch(getVirtualCardPermissions(virtualCardId))
  }, [virtualCard?.status, virtualCardId])

  useEffect(() => {
    if (virtualCard === undefined) return

    if (!virtualCard.isBillPay) {
      // user is trying to access a regular virtual card, redirect to the virtual card url
      dispatch(connectedReplace(deactivateVirtualCardUrl(virtualCardId)))
    }
  }, [virtualCard])

  return <DeactivateVirtualCardContent virtualCard={virtualCard} />
}

export default DeactivateBillPayCard
